import { Eyebrow, Reveal } from '../ui';
import { Link } from 'react-router-dom';

/** « Notre vision »: titre à gauche, texte à droite, puis grande photo pleine largeur avec un lien en surimpression. */
export default function VisionBlock({ heading, text, image, cta }: { heading: string; text: string; image?: string; cta: { label: string; to: string } }) {
  return (
    <section className="bg-white py-16 text-black md:py-28">
      <div className="site-container">
        <Eyebrow className="mb-4">Notre vision</Eyebrow>
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-24">
          <Reveal><h2 className="font-display text-[2rem] font-bold normal-case leading-[1.1] tracking-normal text-black md:text-[2.75rem]">{heading}</h2></Reveal>
          <Reveal delay={0.08}><p className="text-[1.0625rem] leading-relaxed">{text}</p></Reveal>
        </div>
        {image && (
          <Reveal>
            <Link to={cta.to} className="group relative mt-12 block aspect-[16/8] overflow-hidden bg-charcoal">
              <img src={image} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-700 ease-out group-hover:scale-[1.03]" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex items-center gap-4 p-6 md:p-10">
                <span className="font-sans text-[1.5rem] font-bold leading-tight text-white md:text-[2rem]">{cta.label}</span>
                <span aria-hidden className="h-0.5 w-10 bg-brand transition-all duration-300 group-hover:w-20" />
              </div>
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
}
